export enum PayLinkSteps {
  Details,
  Waiver,
  Information,
  Payment,
}

export enum WaiverSusbscriptionTrigger {
  FirstSingup = 1,
  AllSignup = 2,
  OnlyForSelectServiceCatogory = 3,
}

export enum TrackMode {
  StaffWebApp = 1,
  StaffMobileApp = 2,
  ClientMobileApp = 3,
  ClientPurchasePortal = 4,
  ClientWebsiteWidget = 5,
  FFMavrick = 6,
  ClientWebSignup = 7,
  FFHangfireJob = 8,
  Widget = 9,
  ClassPass = 10,
  FFConsumerApp = 11,
}

export enum Status {
  InActive = 0,
  Active = 1,
}

export enum YesNo {
  Yes = 1,
  No = 0,
}

export interface Tenant_Access {
  id: number;
  name_primary_language: string;
  name_secondary_language: string;
}

export interface Ienum<T> {
  key: string | T;
  value: string | T;
}

//#region Staff

export enum StaffStatus {
  Invited = 0,
  Active = 1,
  Suspended = 2,
  Terminated = 3,
}

export enum IPSettings {
  Unrestricted = 1,
  CentreIPs = 2,
  CentrePlusStaffIPs = 3,
  Staff = 4,
}

export enum Roles {
  Admin = 1,
  Staff = 2,
  Member = 3,
  FFAdmin = 4,
}

export enum StaffGender {
  Female = 1,
  Male = 2,
  Transgender = 3,
  NonBinaryOrNonConforming = 4,
  PreferNotToRespond = 5,
}


export enum ClientGender {
  Female = 1,
  Male = 2,
  Transgender = 3,
  NonBinaryOrNonConforming = 4,
  PreferNotToRespond = 5,
}

export enum Crown {
  SilverCrown = 'silver-crown',
  GrayCrown = 'gray-crown',
  GoldCrown = 'gold-crown',
  Default = 'default',
}
export enum CoinIcons {
  LessSpentIcon = 'less-spent-icon',
  MediumSpentIcon = 'medium-spent-icon',
  MostSpentIcon = 'most-spent-icon',
  Default = 'default',
}
export enum ClientRegular {
  Regular = 0,
  IRRegular = 1,
}

export enum ClientStatus {
  Prospect = 1,
  Trial = 2,
  Client = 3,
  ClientNonMember = 4,
  ExClient = 5,
  BlockedClient = 6,
  ExClientNonMember = 7,
}

export enum ClientSubStatus {
  FutureClient = 1,
  ActiveCLient = 2,
  FrozenClient = 3,
  SuspendedClient = 4,
  ExMemberCancelled = 5,
  ExMemberExpired = 6,
  ExMemberTransferred = 7,
  Prospect = 8,
  Trial = 9,
  BlockedClient = 10,
  ClientNonMember = 11,
  ExClientNonMember = 12,
}

export enum ClientChannel {
  Online = 1,
  WalkIn = 2,
  Phone = 3,
  DataEntry = 4,
  Other = 5,
}

export enum DeletionRequestStatus {
  Pending = 0,
  Declined = 1,
  Completed = 2,
}

export enum Gender {
  male = 'Male',
  female = 'Female',
  other = 'Other',
}
export enum EnquirySource {
  web = 'web',
  walkIn = 'walk-in',
  phone = 'phone',
}

export enum TimeLine {
  BeyondFiveYears = 5,
  BeyondThreeYears = 3,
  BeyondOneYears = 1,
  TimeAgo = 'ago',
  TimeToGO = 'togo',
}

export enum GridData {
  RowLoaderTime = 1200,
  DefaultCurrentPage = 1,
  DefaultInitilaPage = 0,
  DefaultPageSize = 10,
  DefaultPageItems = 10,
  DefaultPages = 10,
}
export enum ElasticProviderName {
  Clients = 'Clients',
  Actions = 'Actions',
  KbDocuments = 'KbDocuments',
}
//#endregion Client

//#region paylink

export enum PaymentGatewaySupported {
  Offline = 0,
  RazorpayIndia = 1,
  PayenginUSA = 2,
  TwoC2pVietnam = 3,
  TwoC2pSingapore = 4,
  TwoC2pMalaysia = 5,
  EzypayAustralia = 6,
  EzypaySingapore = 7,
  EzypayMalaysia = 8,
  EzypayPhilippines = 9,
  PayenginePhilippines = 10,
  PayenginCanada = 11,
  StripeCanada = 12,
  StripeUSA = 13,
  TapSaudi = 14,
  TapUAE = 15,
  TapKuwait = 16,
  TapOman = 17,
  TapBahrain = 18,
  TapEgypt = 19,
  EzypayNewZeland = 20,
  EzypaySouthKoria = 21,
  StripeUAE = 22,
  StripeNorway = 23,
}

export enum MerchantOnboardingStatus {
  Iniitiated = 1,
  Inprogress = 2,
  Successfull = 3,
  Failed = 4,
}

export enum PaymentGatewayType {
  Primary = 1,
  ApplePay = 2,
  GooglePay = 3,
  AmazonPay = 4,
  UPI = 5,
  Paytm = 6,
}

export enum PayModeType {
  Cash = 1,
  Debit = 2,
  Credit = 3,
  Emandate = 4,
  UPI = 5,
  Paytm = 6,
  AmazonPay = 7,
  Venmo = 8,
  ACH = 9,
  Cheque = 10,
  Sodexo = 11,
  NetBanking = 12,
  ApplePay = 13,
  CAREEM = 14,
  KNET = 15,
  OMANPAY = 16,
  FAWRY = 17,
  BENEFIT = 18,
  MADA = 19,
  TABBY = 20,
  CARD = 100,
}
//#endregion paylink

//#region Waiver
export enum WaiverVariablesType {
  CheckBox,
  Date,
  Sign,
  TextBox,
}
//#endregion Waiver

export enum FundingModel {
  PREPAID = 'PREPAID',
  POSTPAID = 'POSTPAID',
  CO_PAY = 'CO_PAY',
  CREDIT_LINE = 'CREDIT_LINE',
  FAMILY = 'FAMILY',
}

export enum CommunicationDirection {
  Incoming = 1,
  Outgoing = 2,
}

export enum TrialType {
  DaysBased = 1,
  ClassBased = 2,
  ApptBased = 3,
}

export enum TrialStatus {
  Active = 1,
  Inactive = 2,
  Expired = 3,
  Cancelled = 4,
}

export enum SalesAndPayments {
  Sales = 1,
  Payments = 2,
}

export enum NotificationChannels {
  None = 0,
  Email = 1,
  SMS = 2,
  WhatsApp = 3,
  MobileNotification = 4,
  Desktop = 5,
  Task = 6,
  Push = 7,
  Webhook = 8,
}

export enum CompactPrintSize {
  Size80x80 = 1,
  Size57x50 = 2,
  Size57x40 = 3,
}

export enum ClientChannelString {
  Online = 'Online',
  WalkIn = 'WalkIn',
  Phone = 'Phone',
  DataEntry = 'DataEntry',
  Other = 'Other',
}

export enum EmailSendType {
  FreeForm,
  Bulk,
  Campaign,
  Automation,
}

export enum SMSSendType {
  FreeForm,
  Bulk,
  Campaign,
  Automation,
}

export enum WhatsAppSendType {
  FreeForm,
  Bulk,
  Campaign,
  Automation,
}

export enum PushNotificationSendType {
  FreeForm,
  Bulk,
  Campaign,
  Automation,
}

export enum TaskCreateType {
  Single,
  Bulk,
  Campaign,
  Automation,
}

export enum Weekday {
  Sunday,
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday,
}

export enum SubscriptionPaymentMethodType {
  Primary = 1,
  Secondary = 2,
}

export enum StaffPreferences {
  Profile = 1,
  Notification = 2,
  Task = 3,
  Availability = 4,
  Language = 5,
  Commission = 6,
}

export enum EzypayDocumentType {
  tax_invoice,
  detail_report,
  summary_report,
}

export enum NotificationSubscriptionType {
  IncomingSMS = 2,
  IncomingEmail = 3,
  IncomingWhatsApp = 4,
}

export enum NotificationLevel {
  All = 1,
  Self = 2,
  Department = 3,
}

export enum LoginProvider {
  FF,
  Google,
  Apple,
  Microsoft,
}

export enum TrueFalse {
  True = 1,
  False = 0,
}

export enum ExternalCmsSupported {
  NoExternalCMS = 0,
  AnyTimeFitnessIndia = 1,
  AnyTimeFitnessUSA = 2,
  AnyTimeFitnessCanada = 3,
  AnyTimeFitnessAustralia = 4,
  AnyTimeFitnessVietnam = 5,
  AnyTimeFitnessNewZealand = 6,
  AnyTimeFitnessSaudiArabia = 7,
  AnyTimeFitnessUAE = 8,
  AnyTimeFitnessKuwait = 9
}

export enum ContactStatus {
  Open,
  Closed,
}

export enum ContactSource {
  Email,
  WhatsApp,
  Facebook,
  LinkedIn,
  Instagram,
  Twitter,
  TikTok,
  YouTube,
}

export enum SponsorType {
  None = 0,
  Corporate = 1,
  Family = 2,
  Insurer = 3,
  Govt = 4,
}

export enum AccessControlVendor{
    Suprema = 1,
    Kissi = 2,
    Airfob = 3  
}
